import { render } from "./ContextPage.vue?vue&type=template&id=53938637&scoped=true"
import script from "./ContextPage.vue?vue&type=script&lang=js"
export * from "./ContextPage.vue?vue&type=script&lang=js"

import "./ContextPage.vue?vue&type=style&index=0&id=53938637&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-53938637"]])

export default __exports__